import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { VideoSDKMeeting } from "@videosdk.live/rtc-js-prebuilt";

const JoinSessionAsAttendee = () => {
  const obj = JSON.parse(localStorage.getItem("authEventKagoUser"));
  const userFullName = `${obj?.data?.data?.firstName} ${obj?.data?.data?.lastName}`;
  const userId = obj?.data?.data?.id;
  const params = useParams();
  const eventID = params.eventID;
  const sessionID = params.sessionID;
  const eventName = params.eventName;
  const myEventName = eventName.replace(/-/g, " ");
  document.title = `${myEventName} | Conference`;

  useEffect(() => {
    const apiKey = process.env.REACT_APP_VIDEOSDK_API;
    const meetingId = `${sessionID}`;
    const name = `${userFullName}`;

    const config = {
      name: name,
      meetingId: meetingId,
      apiKey: apiKey,
      participantId: userId,
      region: "sg001", // region for new meeting

      // containerId: null,
      redirectOnLeave: `https://events.kago.digital/${eventName}/c/${eventID}`,
      theme: "DARK",
      micEnabled: true,
      webcamEnabled: true,
      participantCanToggleSelfWebcam: true,
      participantCanToggleSelfMic: true,
      participantCanLeave: true,

      chatEnabled: true,
      screenShareEnabled: false,
      pollEnabled: true,
      whiteboardEnabled: false,
      raiseHandEnabled: true,

      recording: {
        autoStart: false, // auto start recording on participant joined
        enabled: false,
        webhookUrl: "https://www.videosdk.live/callback",
        awsDirPath: `/kago/Confererence/${meetingId}/`, // automatically save recording in this s3 path
      },

      livestream: {
        autoStart: false,
        enabled: false,
      },

      layout: {
        type: "SPOTLIGHT", // "SPOTLIGHT" | "SIDEBAR" | "GRID"
        priority: "SPEAKER", // "SPEAKER" | "PIN",
        // gridSize: 3,
      },

      branding: {
        enabled: false,
        logoURL: null,
        name: myEventName,
        poweredBy: false,
      },

      permissions: {
        pin: true,
        askToJoin: true, // Permission
        canCreatePoll: false,
        toggleParticipantMic: false,
        toggleParticipantWebcam: false,
        drawOnWhiteboard: false,
        toggleWhiteboard: false,
        toggleVirtualBackground: true,
        toggleRecording: false,
        toggleLivestream: false,
        removeParticipant: false,
        endMeeting: false,
        changeLayout: false,
      },

      joinScreen: {
        visible: true,
        title: myEventName,
        // meetingUrl: window.location.href, // Meeting joining url
      },

      leftScreen: {
        // visible when redirect on leave not provieded
        actionButton: {
          // optional action button
          label: "Kago Events", // action button label
          href: `https://events.kago.digital/${eventName}/c/${eventID}`, // action button href
        },
      },

      notificationSoundEnabled: true,

      debug: false, // pop up error during invalid config or netwrok error

      maxResolution: "hd", // "hd" or "sd"
      // you can change made to conference or viewer
      mode: "CONFERENCE",
    };

    const meeting = new VideoSDKMeeting();
    meeting.init(config);
  }, []);

  return <div></div>;
};

export default JoinSessionAsAttendee;
